// Get All TATA Records Constants
export const GET_ALL_TATA_RECORDS_REQUEST = 'GET_ALL_TATA_RECORDS_REQUEST'
export const GET_ALL_TATA_RECORDS_SUCCESS = 'GET_ALL_TATA_RECORDS_SUCCESS'
export const GET_ALL_TATA_RECORDS_FAIL = 'GET_ALL_TATA_RECORDS_FAIL'
export const GET_ALL_TATA_RECORDS_RESET = 'GET_ALL_TATA_RECORDS_RESET'

// Get TATA Record By ID Constants
export const GET_TATA_RECORD_BY_ID_REQUEST = 'GET_TATA_RECORD_BY_ID_REQUEST'
export const GET_TATA_RECORD_BY_ID_SUCCESS = 'GET_TATA_RECORD_BY_ID_SUCCESS'
export const GET_TATA_RECORD_BY_ID_FAIL = 'GET_TATA_RECORD_BY_ID_FAIL'
export const GET_TATA_RECORD_BY_ID_RESET = 'GET_TATA_RECORD_BY_ID_RESET'

// Create TATA Record Constants
export const CREATE_TATA_RECORD_REQUEST = 'CREATE_TATA_RECORD_REQUEST'
export const CREATE_TATA_RECORD_SUCCESS = 'CREATE_TATA_RECORD_SUCCESS'
export const CREATE_TATA_RECORD_FAIL = 'CREATE_TATA_RECORD_FAIL'
export const CREATE_TATA_RECORD_RESET = 'CREATE_TATA_RECORD_RESET'

// Update TATA Record Constants
export const UPDATE_TATA_RECORD_REQUEST = 'UPDATE_TATA_RECORD_REQUEST'
export const UPDATE_TATA_RECORD_SUCCESS = 'UPDATE_TATA_RECORD_SUCCESS'



export const UPDATE_TATA_RECORD_FAIL = 'UPDATE_TATA_RECORD_FAIL'
export const UPDATE_TATA_RECORD_RESET = 'UPDATE_TATA_RECORD_RESET'

// Delete TATA Record Constants
export const DELETE_TATA_RECORD_REQUEST = 'DELETE_TATA_RECORD_REQUEST'
export const DELETE_TATA_RECORD_SUCCESS = 'DELETE_TATA_RECORD_SUCCESS'
export const DELETE_TATA_RECORD_FAIL = 'DELETE_TATA_RECORD_FAIL'
export const DELETE_TATA_RECORD_RESET = 'DELETE_TATA_RECORD_RESET'

// Bulk Delete TATA Records Constants
export const BULK_DELETE_TATA_RECORDS_REQUEST = 'BULK_DELETE_TATA_RECORDS_REQUEST'
export const BULK_DELETE_TATA_RECORDS_SUCCESS = 'BULK_DELETE_TATA_RECORDS_SUCCESS'
export const BULK_DELETE_TATA_RECORDS_FAIL = 'BULK_DELETE_TATA_RECORDS_FAIL'
export const BULK_DELETE_TATA_RECORDS_RESET = 'BULK_DELETE_TATA_RECORDS_RESET'

// Clear All TATA Records Constants
export const CLEAR_ALL_TATA_RECORDS_REQUEST = 'CLEAR_ALL_TATA_RECORDS_REQUEST'
export const CLEAR_ALL_TATA_RECORDS_SUCCESS = 'CLEAR_ALL_TATA_RECORDS_SUCCESS'
export const CLEAR_ALL_TATA_RECORDS_FAIL = 'CLEAR_ALL_TATA_RECORDS_FAIL'
export const CLEAR_ALL_TATA_RECORDS_RESET = 'CLEAR_ALL_TATA_RECORDS_RESET'

// Import TATA Records Constants
export const IMPORT_TATA_RECORDS_REQUEST = 'IMPORT_TATA_RECORDS_REQUEST'
export const IMPORT_TATA_RECORDS_SUCCESS = 'IMPORT_TATA_RECORDS_SUCCESS'
export const IMPORT_TATA_RECORDS_FAIL = 'IMPORT_TATA_RECORDS_FAIL'
export const IMPORT_TATA_RECORDS_RESET = 'IMPORT_TATA_RECORDS_RESET'

// Import Progress Constants
export const IMPORT_TATA_PROGRESS_UPDATE = 'IMPORT_TATA_PROGRESS_UPDATE'
export const IMPORT_TATA_PROGRESS_RESET = 'IMPORT_TATA_PROGRESS_RESET'

// Export TATA Records Constants
export const EXPORT_TATA_RECORDS_REQUEST = 'EXPORT_TATA_RECORDS_REQUEST'
export const EXPORT_TATA_RECORDS_SUCCESS = 'EXPORT_TATA_RECORDS_SUCCESS'
export const EXPORT_TATA_RECORDS_FAIL = 'EXPORT_TATA_RECORDS_FAIL'
export const EXPORT_TATA_RECORDS_RESET = 'EXPORT_TATA_RECORDS_RESET'

// Get TATA Stats Constants
export const GET_TATA_STATS_REQUEST = 'GET_TATA_STATS_REQUEST'
export const GET_TATA_STATS_SUCCESS = 'GET_TATA_STATS_SUCCESS'
export const GET_TATA_STATS_FAIL = 'GET_TATA_STATS_FAIL'
export const GET_TATA_STATS_RESET = 'GET_TATA_STATS_RESET'

// Get TATA By Filters Constants
export const GET_TATA_BY_FILTERS_REQUEST = 'GET_TATA_BY_FILTERS_REQUEST'
export const GET_TATA_BY_FILTERS_SUCCESS = 'GET_TATA_BY_FILTERS_SUCCESS'
export const GET_TATA_BY_FILTERS_FAIL = 'GET_TATA_BY_FILTERS_FAIL'
export const GET_TATA_BY_FILTERS_RESET = 'GET_TATA_BY_FILTERS_RESET'

// for task status 
export const SYNC_TATA_TASK_STATUS_REQUEST = 'SYNC_TATA_TASK_STATUS_REQUEST';
export const SYNC_TATA_TASK_STATUS_SUCCESS = 'SYNC_TATA_TASK_STATUS_SUCCESS';
export const SYNC_TATA_TASK_STATUS_FAIL = 'SYNC_TATA_TASK_STATUS_FAIL';
export const SYNC_TATA_TASK_STATUS_RESET = 'SYNC_TATA_TASK_STATUS_RESET';